<template>
  <div class="lang-tabs el-form-item">
    <ul>
      <li
        v-for="(value, key, index) in languages"
        v-bind:key="key"
        :class="{'is-active' : isActiveTab(index)}"
      >
        <a @click="active = index">{{value}}</a>
      </li>
    </ul>

    <div v-for="(value, key, index) in languages" v-if="isActiveTab(index)">
      <h5 v-if="param" @click="$router.push(param)">{{ input[key] ? input[key] : '/' }}</h5>
      <p v-else-if="isHtml" v-html="input[key]"></p>
      <div v-else>{{ input[key] ? input[key] : '/' }}</div>
    </div>
  </div>
</template>

<script>
import model from "@/model/index";

export default {
  props: {
    input: {
      isRequired: true
    },
    isHtml: {
      isRequired: false
    },
    param: {
      isRequired: false
    }
  },
  data() {
    return {
      active: 0
    };
  },
  computed: {
    languages() {
      return model.getLanguages();
    }
  },
  watch: {
    input(data) {
      this.input = data;
    }
  },
  methods: {
    isActiveTab(id) {
      return this.active === id;
    }
  }
};
</script>


<style scoped>
.el-form-item.is-error .el-input__inner {
  border-color: #f56c6c;
}

.el-form-item ul {
  padding: 0;
}

.el-form-item ul li {
  list-style: none;
  display: inline-block;
  padding-right: 20px;
}

.el-form-item ul li a {
  font-weight: bold;
  cursor: pointer;
}

.el-form-item ul li.is-active {
  color: #409eff;
}

h5 {
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.el-form-item {
  margin-bottom: 0px !important;
}
.el-input {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/LangTabs/LangTabsView.vue